import type { ExtensibilityModeEnum } from 'owa-addins-types';
import { updateSidePaneType } from 'owa-calendar-compose-form-actions';
import SidePaneType from 'owa-calendar-sidepane/lib/schema/SidePaneType';

export const openTaskPane = (mode: ExtensibilityModeEnum, formId: string) => (): void => {
    updateSidePaneType(formId, SidePaneType.Addins);
};

export const closeTaskPane = (mode: ExtensibilityModeEnum, formId: string) => (): void => {
    updateSidePaneType(formId, SidePaneType.None);
};
